import { WithLoadingState } from '../with-loading.interface';

export function showLoading(): (state: WithLoadingState) => Partial<WithLoadingState> {
  return (state) => ({
    isLoadingCounter: state.isLoadingCounter + 1,
  });
}

export function hideLoading(): (state: WithLoadingState) => Partial<WithLoadingState> {
  return (state) => ({
    isLoadingCounter: Math.max(0, state.isLoadingCounter - 1),
  });
}
